import type { FAQ } from "@brookbush/types";

import type { PortableTextBlock } from "@portabletext/types";

const plainBlocks = (text: string): PortableTextBlock[] => [
	{
		_type: "block",
		_key: "a",
		style: "normal",
		markDefs: [],
		children: [{ _type: "span", _key: "s", text, marks: [] }],
	},
];

/**
 * Homepage copy overrides (Sep 22, 2026 change doc).
 * NCCA mark homes on this page: hero announcement bar + accreditations entry only.
 */
export const HOMEPAGE = {
	seoTitle:
		"Brookbush Institute | Evidence-Based Fitness & Rehab Education, Certifications, and the NCCA-Accredited CPT Exam",
	seoDescription:
		"4 certifications, 200+ courses, 500+ videos, and an AI tutor for trainers, coaches, and rehab professionals — all in one monthly membership. Home of the NCCA-accredited Brookbush Institute CPT Certification exam.",
	h1: "4 Certifications, 200+ Courses, 500+ Videos, an AI Tutor — and so much more.",
	announcementText:
		"New: the Brookbush Institute CPT Certification exam is NCCA-accredited.",
	announcementLinkLabel: "Learn more →",
	announcementHref: "/exam-portal",
	cptProgramsLinkLabel: "Explore the CPT programs →",
	cptProgramsHref: "/info/certified-personal-trainer",
	footerCtaSentence:
		"The BI is the only approved continuing-education provider with a true monthly membership model (cancel anytime) — and the home of the NCCA-accredited Brookbush Institute CPT Certification exam.",
	nccaFaqQuestion:
		"Is the Brookbush Institute CPT certification NCCA-accredited?",
	nccaFaqAnswer:
		"Yes. The Brookbush Institute CPT Certification exam was accredited by the National Commission for Certifying Agencies (NCCA) on September 22, 2026. It is a standalone, proctored exam, open to anyone; no course or membership is required to sit for it, and the exam fee is separate from membership. The BI-CPT Certificate, the Study Plan, the Practice Exam, and the Exam Coach — all included in membership — are how we recommend you prepare. Details at brookbushinstitute.com/exam-portal.",
	whatWeOfferCertificationsLine:
		"Comprehensively evidence-based, outcome-driven education — and the home of the NCCA-accredited CPT Certification exam.",
	nccaExamCounterTitle: "NCCA-Accredited CPT Exam",
	nccaExamCounterDescription:
		"A standalone, proctored Certified Personal Trainer certification exam — open to anyone.",
	nccaExamCounterHref: "/exam-portal",
} as const;

export const getHomepageFaqs = (cmsFaqs: FAQ[] = []): FAQ[] => {
	const nccaFaq: FAQ = {
		_key: "homepage-ncca-faq",
		question: HOMEPAGE.nccaFaqQuestion,
		answer: plainBlocks(HOMEPAGE.nccaFaqAnswer),
	};

	const withoutDuplicate = cmsFaqs.filter(
		(faq) =>
			faq.question.toLowerCase() !== HOMEPAGE.nccaFaqQuestion.toLowerCase(),
	);

	return [nccaFaq, ...withoutDuplicate];
};
